/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaUiAEjectIcon16Light } from './MediaUiAEjectIcon16Light';
import { MediaUiAEjectIcon16Regular } from './MediaUiAEjectIcon16Regular';
import { MediaUiAEjectIcon16Solid } from './MediaUiAEjectIcon16Solid';
import { MediaUiAEjectIcon20Light } from './MediaUiAEjectIcon20Light';
import { MediaUiAEjectIcon20Regular } from './MediaUiAEjectIcon20Regular';
import { MediaUiAEjectIcon20Solid } from './MediaUiAEjectIcon20Solid';
import { MediaUiAEjectIcon24Regular } from './MediaUiAEjectIcon24Regular';
import { MediaUiAEjectIcon24Solid } from './MediaUiAEjectIcon24Solid';
import { MediaUiAEjectIcon32Regular } from './MediaUiAEjectIcon32Regular';
import { MediaUiAEjectIcon64Regular } from './MediaUiAEjectIcon64Regular';
var sizes = {
    16: {
        light: MediaUiAEjectIcon16Light,
        regular: MediaUiAEjectIcon16Regular,
        solid: MediaUiAEjectIcon16Solid,
    },
    20: {
        light: MediaUiAEjectIcon20Light,
        regular: MediaUiAEjectIcon20Regular,
        solid: MediaUiAEjectIcon20Solid,
    },
    24: {
        regular: MediaUiAEjectIcon24Regular,
        solid: MediaUiAEjectIcon24Solid,
    },
    32: {
        regular: MediaUiAEjectIcon32Regular,
    },
    64: {
        regular: MediaUiAEjectIcon64Regular,
    },
};
export var MediaUiAEjectIcon = forwardRef('MediaUiAEjectIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
